import API from 'services/api';

export const deleteCalculationPayment = (paymentId: string) => {
  return API.delete(`/api/accommodation/calculations/payments/${paymentId}`);
};
